(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.sheetsBounce = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var MAX_OFFSET = 60;
  var BOUNCE_EFFECT = Math.E;
  var CLOSE_THRESHOLD = 80;

  exports.default = {
    data: function data() {
      return {
        touchstartY: 0,
        touchmoveY: 0,
        dialogStyle: '',
        dialogDom: null
      };
    },

    methods: {
      calculateOffset: function calculateOffset() {
        if (this.slideDownDisappear === false) {
          return this.dampingFunc(this.touchmoveY, MAX_OFFSET) + 'px';
        }
        if (this.touchmoveY < 0) {
          return this.touchmoveY / 20 - MAX_OFFSET * (1 - 1 / Math.pow(BOUNCE_EFFECT, -this.touchmoveY / 100)) + 'px';
        } else {
          if (this.$refs.bounceDialog && this.$refs.bounceDialog.slideDownOut) {
            // 向下滑动可关闭弹窗
            return this.touchmoveY + 'px';
          } else {
            // 向下滑动不可关闭弹窗
            return this.touchmoveY / 20 - MAX_OFFSET * (1 - 1 / Math.pow(BOUNCE_EFFECT, -this.touchmoveY / 400)) + 'px';
          }
        }
      },

      // 阻尼函数
      dampingFunc: function dampingFunc(x, max) {
        var y = Math.abs(x);
        y = 2.82231 * max / (1 + 4338.47 / Math.pow(y, 1.14791));
        return Math.round(x < 0 ? -y : y);
      },
      handleTouchstart: function handleTouchstart(eve) {
        if (!this.dialogDom) {
          this.dialogDom = this.$refs.bounceDialog.$el.querySelector('.nx-popup-box');
        }
        this.dialogStyle = this.dialogDom.style;
        this.dialogDom.style.transform = 'translateY(0)';
        this.dialogDom.style.transition = 'none';
        this.touchstartY = eve.touches[0].clientY;
        this.dialogDomHeight = this.dialogDom.clientHeight;
      },
      handleTouchmove: function handleTouchmove(eve) {
        this.touchmoveY = eve.touches[0].clientY - this.touchstartY;
        if (this.touchmoveY < 0) {
          this.dialogDom.style.height = 'calc(' + this.dialogDomHeight + 'px - ' + this.calculateOffset() + ')';
          // if (this.$refs.bounceDialog.mode == 1) {
          //   this.dialogDom.style.height = `calc(${
          //     this.dialogDomHeight
          //   }px - ${this.calculateOffset()})`
          // } else if (this.$refs.bounceDialog.mode == 2) {
          //   this.dialogDom.style.height = `calc(${
          //     this.dialogDomHeight
          //   }px - ${this.calculateOffset()})`
          // } else if (this.$refs.bounceDialog.mode == 3) {
          //   this.dialogDom.style.height = `calc(${
          //     this.dialogDomHeight
          //   }px - ${this.calculateOffset()})`
          // }

          // 原先的方案是改蒙层的底部背景色来实现，但是深色模式下需要兼容，相对麻烦
          // this.dialogDom.previousElementSibling.style.background =
          //   'linear-gradient(to bottom, rgba(0,0,0,.3) 85%, #fff 15%)'
        } else {
          this.dialogDom.style.transform = 'translateY(' + this.calculateOffset() + ')';
        }
      },
      handleTouchend: function handleTouchend(close) {
        var _this = this;

        this.$nextTick(function () {
          if (_this.touchmoveY < CLOSE_THRESHOLD) {
            _this.dialogDom.style.height = _this.dialogDomHeight + 'px';
            // if (this.$refs.bounceDialog.mode == 1) {
            //   this.dialogDom.style.height = this.dialogDomHeight + 'px'
            // } else if (this.$refs.bounceDialog.mode == 2) {
            //   this.dialogDom.style.height = this.dialogDomHeight + 'px'
            // } else if (this.$refs.bounceDialog.mode == 3) {
            //   this.dialogDom.style.height = this.dialogDomHeight + 'px'
            // }

            if (_this.touchmoveY < 0) {
              _this.dialogDom.style.transition = 'height 0.2s ease-out';
              _this.dialogDom.style.transform = 'translateY(0)';
            } else {
              _this.dialogDom.style.transition = 'transform 0.2s ease-out';
              _this.dialogDom.style.transform = 'translateY(0)';
            }
            setTimeout(function () {
              _this.dialogDom.removeAttribute('style');
            }, 200);
          } else {
            _this.dialogDom.removeAttribute('style');
            if (_this.$refs.bounceDialog && _this.$refs.bounceDialog.slideDownOut) {
              _this.$nextTick(function () {
                typeof close === 'function' && close();
              });
            }
          }
        });
      }
    }
  };
});